"use client"

import { Button } from "@/components/ui"
import { track } from "@/lib/integrations/analytics/tracker"
import { ArrowRight, Lock } from "lucide-react"

export const PremiumText = ({feature, text, noIcon = false}:{feature?:string, text?:string, noIcon?: boolean}) => {
  const navigateToSubscribe = () => {
    track('Premium Feature Clicked', {
      feature: feature,
      text: text,
    });
    
    window.location.href = '/subscribe';
  }
  
  return (
    <div className="bg-slate-50 border border-slate-200  flex flex-col items-center gap-2 rounded-lg p-6 text-xs text-slate-600">
      { !noIcon && (<div className="bg-slate-100 rounded-full p-3 mb-3">
        <Lock className="h-8 w-8 text-slate-500" />
      </div>) }
      <h4 className="font-medium mb-1">Premium Feature</h4>
      <p className="text-slate-500 text-sm mb-4 max-w-xs text-center">
        { text ? text : 'Upgrade to access this feature.' }
      </p>
      <Button type="button" onClick={()=>navigateToSubscribe()} variant="secondary" size="sm">
        Upgrade now
        <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
     </div>
  )
}